import script from "./CaskMainArticleContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskMainArticleContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBars,QImg,QBtn,QIcon});
